document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-list ol li:first-of-type').forEach(el => {
    el.classList.add('active');
  });


  document.querySelectorAll('.custom-list ol li').forEach(listElement => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        listElement.closest('ol').querySelectorAll('li').forEach(li => li.classList.remove('active'));
        listElement.classList.add('active');
      }
    }, { rootMargin: '-50% 0% -50% 0%', threshold: 0 });
    observer.observe(listElement);
  });


});
